/* assets/menu-mix.js — the menu-order experiment: every session sees ONE fixed
 * random order of the main menu, different sessions see different orders, so
 * position bias and true item appeal become separable.
 *
 * DESIGN:
 *  - the pinned item (Choose by device) is dealt a slot among 1..3 only - it
 *    must never sink, but its 1st-vs-2nd-vs-3rd difference is part of the
 *    question; every other main item is Fisher-Yates-shuffled over the
 *    remaining slots. Submenus keep their server order (V1).
 *  - the order is a pure function of a per-session seed (sessionStorage), so
 *    reopening the menu or navigating never reshuffles under the visitor.
 *  - the shuffle runs at DOMContentLoaded while the drawer is CLOSED - no
 *    flicker; crawlers and no-JS visitors see the merchant's order.
 *
 * MEASUREMENT CONTRACT (consumed by assets/mf-track.js):
 *  - every main item carries data-mx-pos="<1-based slot>" after the shuffle;
 *  - on the FIRST drawer open of the pageview this module reports
 *    menu:cbd_p<n> (where the pinned item stood) - the exposure denominator
 *    for the pinned item's own position curve. Other items need no exposure
 *    log: their slot probabilities are design constants.
 *
 * Kill switch: MX_ON = false and push - the merchant order returns.
 */
(function () {
  'use strict';
  var D = document, W = window;
  var MX_ON = true;
  var PIN_RE = /choose\s*by\s*device|v[áa]laszd.*(modell|k[ée]sz[üu]l[ée]k|telefon)/i;

  function mulberry32(a) {
    return function () {
      a |= 0; a = (a + 0x6D2B79F5) | 0;
      var t = Math.imul(a ^ (a >>> 15), 1 | a);
      t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
      return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
    };
  }

  function boot() {
    if (!MX_ON) { return; }
    /* MENU A/B (review S2): the order/availability experiment lives in the m0 drawer
       only - in m1 it would shuffle and report a hidden menu */
    if (W.__mfMN === 'm1') { return; }
    var menu = D.querySelector('.glossy-drawer-view[data-view="root"] .glossy-drawer-menu');
    if (!menu) { return; }
    var items = [];
    for (var i = 0; i < menu.children.length; i++) {
      if (menu.children[i].classList.contains('glossy-drawer-menu-link')) { items.push(menu.children[i]); }
    }
    if (items.length < 4) { return; } /* nothing meaningful to shuffle */

    var seed = 0;
    try {
      seed = parseInt(sessionStorage.getItem('mf_mx') || '0', 10) || 0;
      if (!seed) {
        seed = Math.floor(Math.random() * 4294967295) + 1;
        sessionStorage.setItem('mf_mx', String(seed));
      }
    } catch (e) { seed = Math.floor(Math.random() * 4294967295) + 1; }
    var rnd = mulberry32(seed);

    var pinned = null;
    var rest = [];
    for (var j = 0; j < items.length; j++) {
      if (!pinned && PIN_RE.test(items[j].textContent || '')) { pinned = items[j]; }
      else { rest.push(items[j]); }
    }
    /* seeded Fisher-Yates over the unpinned items */
    for (var k = rest.length - 1; k > 0; k--) {
      var r = Math.floor(rnd() * (k + 1));
      var tmp = rest[k]; rest[k] = rest[r]; rest[r] = tmp;
    }
    var order = rest;
    var cbdPos = 0;
    if (pinned) {
      cbdPos = 1 + Math.floor(rnd() * 3); /* slots 1..3 only */
      order = rest.slice(0, cbdPos - 1).concat([pinned], rest.slice(cbdPos - 1));
    }
    for (var m = 0; m < order.length; m++) {
      menu.appendChild(order[m]);
      order[m].setAttribute('data-mx-pos', String(m + 1));
    }

    /* two more independent factors from the same seeded stream - availability
       experiments: the popular-designs strip (off / top-as-now / below-the-menu)
       and the in-menu search (on / off). Session-stable like the order. */
    var rootView = D.querySelector('.glossy-drawer-view[data-view="root"]');
    var dsgArm = ['off', 'top', 'bot'][Math.floor(rnd() * 3)];
    var dsg = rootView && rootView.querySelector('[data-glossy-drawer-designs]');
    if (dsg) {
      if (dsgArm === 'off') { dsg.style.display = 'none'; }
      else if (dsgArm === 'bot') { menu.parentNode.insertBefore(dsg, menu.nextSibling); }
    } else { dsgArm = ''; }
    var srchArm = rnd() < 0.5 ? 'on' : 'off';
    var srch = rootView && rootView.querySelector('.glossy-drawer-search');
    if (srch) {
      if (srchArm === 'off') { srch.style.display = 'none'; }
    } else { srchArm = ''; }
    if (rootView) {
      rootView.setAttribute('data-mx-dsg', dsgArm);
      rootView.setAttribute('data-mx-srch', srchArm);
    }

    /* exposure log, once per pageview on the first real drawer open: the pinned
       slot plus both availability arms - these are the denominators, and their
       add/checkout joins answer whether hiding a feature costs money */
    var sent = false;
    D.documentElement.addEventListener('click', function (ev) {
      if (sent || !ev.isTrusted) { return; }
      var t = ev.target;
      if (t && t.closest && t.closest('[data-glossy-drawer-open]')) {
        sent = true;
        try {
          if (W.mfTrackPush) {
            if (pinned && cbdPos) { W.mfTrackPush('mf_menu_step', { mf_step: 'cbd_p' + cbdPos }); }
            if (dsgArm) { W.mfTrackPush('mf_menu_step', { mf_step: 'dsg_' + dsgArm }); }
            if (srchArm) { W.mfTrackPush('mf_menu_step', { mf_step: 'srch_' + srchArm }); }
          }
        } catch (e) {}
      }
    }, true);
  }

  if (D.readyState === 'complete') { boot(); }
  else { D.addEventListener('DOMContentLoaded', boot, false); }
})();
